import e from "./LinkButton.vue.js";
import { useLocalization as t } from "./localization/index.js";
import { formatExample as n } from "./helpers/format-example.js";
import { Fragment as r, computed as i, createCommentVNode as a, createElementBlock as o, createElementVNode as s, createTextVNode as c, createVNode as l, defineComponent as u, normalizeClass as d, openBlock as f, ref as p, renderList as m, toDisplayString as h, unref as g, useId as _, withCtx as v } from "vue";
import { isObject as y, isObjectLike as b } from "@scalar/helpers/object/is-object";
import { ScalarIcon as x } from "@scalar/components/icon";
import { useClipboard as S } from "@scalar/use-hooks/useClipboard";
import { onClickOutside as C, onKeyStroke as w } from "@vueuse/core";
//#region src/schema/SchemaPropertyExamples.vue?vue&type=script&setup=true&lang.ts
var T = ["id"], E = ["aria-label"], D = ["id"], O = ["aria-label", "onClick"], k = 500, A = /*@__PURE__*/ u({
	__name: "SchemaPropertyExamples",
	props: {
		align: { default: "center" },
		examples: {},
		example: {}
	},
	setup(u) {
		let { copyToClipboard: A } = S(), { translate: j } = t(), M = i(() => u.example !== void 0), N = i(() => b(u.examples) ? u.examples : {}), P = i(() => Object.keys(N.value).length > 0), F = i(() => Object.keys(N.value).length === 1 ? j("schema.example") : j("schema.examples"));
		function I(e) {
			if (y(e)) {
				if ("value" in e) return e.value;
				if ("externalValue" in e) return e.externalValue;
			}
			return e;
		}
		let L = p(null), R = p(null), z = p(!1), B = _(), V = p(null), H = p(null), U = p(!1), W = _(), G = !1, K = 0, q = !1, J = () => {
			G = !0, window.clearTimeout(K), K = window.setTimeout(() => {
				G = !1;
			}, k);
		}, Y = (e, t) => {
			let n = e.relatedTarget;
			return !(n instanceof Node) || !t?.contains(n);
		}, X = () => {
			!G && !q && (z.value = !0);
		}, Z = (e) => {
			Y(e, L.value) && (z.value = !1);
		}, Q = () => {
			!G && !q && (U.value = !0);
		}, ee = (e) => {
			Y(e, V.value) && (U.value = !1);
		};
		C(L, () => {
			z.value = !1;
		}), C(V, () => {
			U.value = !1;
		});
		let $ = (e, t, n) => {
			if (!e.value) return;
			let r = t.value?.contains(document.activeElement);
			if (e.value = !1, r) {
				let e = n.value, t = e instanceof HTMLElement ? e : e?.$el;
				q = !0, t?.focus?.(), q = !1;
			}
		};
		return w("Escape", () => {
			$(z, L, R), $(U, V, H);
		}), (t, i) => (f(), o(r, null, [M.value ? (f(), o("div", {
			key: 0,
			ref_key: "singleRootRef",
			ref: L,
			class: d(["property-example", { "is-open": z.value }]),
			onFocusin: X,
			onFocusout: Z
		}, [l(e, {
			ref_key: "singleTriggerRef",
			ref: R,
			"aria-controls": g(B),
			"aria-expanded": z.value,
			class: "decoration-dotted",
			onClick: i[0] ||= (e) => z.value = !z.value,
			onPointerdown: J
		}, {
			default: v(() => [c(h(g(j)("schema.example")), 1)]),
			_: 1
		}, 8, ["aria-controls", "aria-expanded"]), s("div", {
			id: g(B),
			class: d(["property-example-value-list", {
				"flex!": z.value,
				"property-example-value-list-start": u.align === "start"
			}])
		}, [s("button", {
			"aria-label": `${g(j)("common.copyExample")}: ${g(n)(u.example)}`,
			class: "property-example-value group",
			type: "button",
			onClick: i[1] ||= (e) => g(A)(g(n)(u.example))
		}, [s("span", null, h(g(n)(u.example)), 1), l(g(x), {
			"aria-hidden": "true",
			class: "group-hover:text-c-1 text-c-3 ml-auto min-h-3 min-w-3",
			icon: "Clipboard",
			size: "xs"
		})], 8, E)], 10, T)], 34)) : a("", !0), P.value ? (f(), o("div", {
			key: 1,
			ref_key: "multipleRootRef",
			ref: V,
			class: d(["property-example", { "is-open": U.value }]),
			onFocusin: Q,
			onFocusout: ee
		}, [l(e, {
			ref_key: "multipleTriggerRef",
			ref: H,
			"aria-controls": g(W),
			"aria-expanded": U.value,
			class: "decoration-dotted",
			onClick: i[2] ||= (e) => U.value = !U.value,
			onPointerdown: J
		}, {
			default: v(() => [c(h(F.value), 1)]),
			_: 1
		}, 8, ["aria-controls", "aria-expanded"]), s("div", {
			id: g(W),
			class: d(["property-example-value-list", {
				"flex!": U.value,
				"property-example-value-list-start": u.align === "start"
			}])
		}, [(f(!0), o(r, null, m(N.value, (e, t) => (f(), o("button", {
			key: t,
			"aria-label": `${g(j)("common.copyExample")}: ${g(n)(I(e))}`,
			class: "property-example-value group",
			type: "button",
			onClick: (t) => g(A)(g(n)(I(e)))
		}, [s("span", null, h(g(n)(I(e))), 1), l(g(x), {
			"aria-hidden": "true",
			class: "text-c-3 group-hover:text-c-1 ml-auto min-h-3 min-w-3",
			icon: "Clipboard",
			size: "xs"
		})], 8, O))), 128))], 10, D)], 34)) : a("", !0)], 64));
	}
});
//#endregion
export { A as default };

//# sourceMappingURL=SchemaPropertyExamples.vue_vue_type_script_setup_true_lang.js.map